/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';
import {
    SET_DEFAULT_MENU_LANGUAGE_STATE,
    SET_MENU_LANGUAGE_IS_ACTIVE,
    SET_MENU_LANGUAGE_VERTICAL_POSITION,
} from './menulanguage.types';

export const setMenuLangaugeVerticalPositionAction = (verticalPosition: number): AnyAction => ({
    type: SET_MENU_LANGUAGE_VERTICAL_POSITION,
    payload: { verticalPosition },
});

export const setIsMenuLanguageActiveAction = (isActive: boolean): AnyAction => ({
    type: SET_MENU_LANGUAGE_IS_ACTIVE,
    payload: {
        isActive,
    },
});

export const setDefaultMenuLanguageStateAction = (
    verticalLimit: number,
    verticalPosition: number,
): AnyAction => ({
    type: SET_DEFAULT_MENU_LANGUAGE_STATE,
    payload: {
        verticalLimit,
        verticalPosition,
    },
});
